import { followPreference } from '../settings/preferences.js';

import './combat-frame.css';

/**
 * A red frame around the screen while the player is in combat: no journey
 * and no mounting until it fades. Only a reminder; the server keeps the
 * time (`combat_lock`) and refuses on its own.
 */
export class CombatFrame {
  private readonly root: HTMLElement;
  private readonly unfollow: () => void;
  private timer: number | undefined;

  constructor() {
    this.root = document.createElement('div');
    this.root.className = 'combat-frame';
    this.root.setAttribute('aria-hidden', 'true');
    document.body.append(this.root);
    // A player may turn the reminder off in the settings; the lock itself stays.
    this.unfollow = followPreference('combatFrame', (enabled) => {
      this.root.hidden = !enabled;
    });
  }

  /** In combat for `ms` more, or out of it at once when 0. */
  show(ms: number): void {
    window.clearTimeout(this.timer);
    this.root.classList.toggle('combat-frame--shown', ms > 0);
    if (ms <= 0) return;
    this.timer = window.setTimeout(() => {
      this.root.classList.remove('combat-frame--shown');
    }, ms);
  }

  destroy(): void {
    window.clearTimeout(this.timer);
    this.unfollow();
    this.root.remove();
  }
}
